export var Status;
(function (Status) {
    Status[Status["NEW"] = 0] = "NEW";
    Status[Status["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    Status[Status["COMPLETED"] = 2] = "COMPLETED";
    Status[Status["CANCELLED"] = 3] = "CANCELLED";
    Status[Status["REVIEWED"] = 5] = "REVIEWED";
    Status[Status["REOPENED"] = 6] = "REOPENED";
    Status[Status["BODYSHOP_REOPENED"] = 7] = "BODYSHOP_REOPENED";
    Status[Status["REPAIRED"] = 8] = "REPAIRED";
})(Status || (Status = {}));
